(() => {
  "use strict";
  function e(e) {
    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
      r = document.querySelectorAll(".js-cart-drawer-item");
    document
      .querySelector(".c-cart-drawer__overlay")
      .addEventListener("click", function (e) {
        e.target.parentNode.classList.remove("active"),
          (document.querySelector("#chat-button").style.display = "block"),
          document.querySelector("body").classList.remove("no-scroll");
      }),
      r.length &&
        r.forEach(function (r) {
          var c = r.querySelector(".c-quantity-cart-increase"),
            i = r.querySelector(".c-quantity-cart-decrease"),
            n = r.querySelector(".c-quantity__amount"),
            a = r.querySelector(".cart-item__close-button");
          i.removeAttribute("disabled");
          r.dataset.variantId;
          var o = parseInt(n.textContent.trim()),
            u = r.dataset.sellingPlan,
            s = parseInt(r.dataset.line);
          c.addEventListener("click", function () {
            o++, (n.textContent = o);
            var r = { line: s, quantity: o, selling_plan: u };
            document
              .querySelector(".js-cart-drawer")
              .classList.add("loader-active"),
              e(r, t);
          }),
            i.addEventListener("click", function () {
              if (o > 1) {
                o--, (n.textContent = o);
                var c = { line: s, quantity: o, selling_plan: u };
                document
                  .querySelector(".js-cart-drawer")
                  .classList.add("loader-active"),
                  e(c, t);
              } else if (1 === o) {
                i.removeAttribute("disabled"), r.remove();
                c = { line: s, quantity: 0, selling_plan: u };
                document
                  .querySelector(".js-cart-drawer")
                  .classList.add("loader-active"),
                  e(c, t);
              }
            }),
            a.addEventListener("click", function () {
              r.remove();
              var c = { line: s, quantity: 0, selling_plan: u };
              document
                .querySelector(".js-cart-drawer")
                .classList.add("loader-active"),
                e(c, t);
            });
        });
    var c,
      i,
      n,
      a,
      o,
      u = document.querySelectorAll(".js-cart-toggle-btn"),
      s = document.querySelector(".c-cart-drawer"),
      d = document.querySelector("body"),
      l = document.querySelectorAll(".js-add-to-cart-upsell");
    if (
      (u.forEach(function (e) {
        e.addEventListener("click", function (e) {
          e.preventDefault(),
            s.classList.toggle("active"),
            (document.querySelector("#chat-button").style.display = "block"),
            s.classList.contains("active")
              ? d.classList.add("no-scroll")
              : d.classList.remove("no-scroll");
        });
      }),
      l)
    ) {
      l.forEach(function (t) {
        t.addEventListener("click", function (t) {
          try {
            var r = {
              id: t.target.dataset.id,
              quantity: t.target.dataset.quantity,
              selling_plan: t.target.dataset.sellingPlan,
            };
            document
              .querySelector(".js-cart-drawer")
              .classList.add("loader-active"),
              e(r, !1);
          } catch (e) {
            throw e;
          }
        });
      });
      new Swiper(".c-cart-drawer__upsell-products.swiper", {
        slidesPerView: 1,
        watchOverflow: !0,
        loop: !0,
        spaceBetween: 20,
        navigation: {
          nextEl: ".cart-upsell-next",
          prevEl: ".cart-upsell-prev",
        },
      });
    }
    "" ===
      (c = document.querySelector(".c-cart-drawer__upsell")).querySelector(
        ".swiper-wrapper"
      ).innerHTML && (c.style.display = "none"),
      (i = document.querySelector(".js-cart-note")),
      (n = document.querySelector(".js-cart-note-hidden")),
      (a = document.querySelector(".cart-drawer__note-label")),
      (o = document.querySelector(".cart-drawer__note-input")),
      i &&
        (i.addEventListener("change", function (e) {
          localStorage.setItem("cartNote", e.target.value),
            n && (n.value = e.target.value);
        }),
        a.addEventListener("click", function () {
          a.classList.add("cart-drawer__note-label--clicked"),
            (a.textContent = "Add your gift message here:"),
            (o.style.display = "block");
        })),
      (function () {
        var e = document.querySelector(".js-cart-note"),
          t = document.querySelector(".js-cart-note-hidden"),
          r = localStorage.getItem("cartNote");
        r && e && ((e.value = r), t && (t.value = r));
      })();
  }
  function t(e) {
    var t;
    t =
      arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
        ? "/cart/change"
        : "/cart/add";
    var r = window.location.origin + t,
      i = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(e),
      };
    fetch(r, i).then(function (e) {
      200 === e.status &&
        (document.querySelector(".js-cart-drawer").classList.add("active"),
        (document.querySelector("#chat-button").style.display = "none"),
        document.querySelector("body").classList.add("no-scroll"),
        c(".js-cart-drawer"),
        c(".js-cart-drawer"));
    });
  }
  function r(e, t) {
    var r;
    (document.querySelector(".js-add-to-cart").dataset.sellingPlan =
      e.target.value),
      t &&
        ((r = parseInt(e.target.value)),
        window.product_plans[0].selling_plans.forEach(function (e) {
          var t;
          e.id === r &&
            ((window.discount = {
              type: e.price_adjustments[0].value_type,
              value: e.price_adjustments[0].value,
            }),
            (t = "".concat(e.price_adjustments[0].value, "%")),
            (document.querySelector(
              'label[for="subscription"]'
            ).innerHTML = `Subscribe and Save <span class="subscription-percent">${t} OFF</span>`),
            (function (e, t) {
              /*var r = document.querySelector(".b-buy-box__product-pricing"),
                c = window.product_price,
                comparePrice = window.product_compare_price / 100; */
              switch (t) {
                case "percentage":
                  !(function (e, t, r) {
                    var c = (e * r) / 100,
                      i = (e - c) / 100,
                      discountAmount = comparePrice - i;
                    if ("ILS" === Shopify.currency.active) {
                      t.querySelector(".price").innerHTML = ""
                        .concat(
                          i.toLocaleString(void 0, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        )
                        .concat(window.currencies[Shopify.currency.active]);
                      if (discountAmount > 0) {
                        t.querySelector(".savings span.money").innerHTML = ""
                          .concat(
                            discountAmount.toLocaleString(void 0, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          )
                          .concat(window.currencies[Shopify.currency.active]);
                      }
                    } else {
                      t.querySelector(".price").innerHTML = ""
                        .concat(window.currencies[Shopify.currency.active])
                        .concat(
                          i.toLocaleString(void 0, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        );
                      if (discountAmount > 0) {
                        t.querySelector(".savings span.money").innerHTML = ""
                          .concat(window.currencies[Shopify.currency.active])
                          .concat(
                            discountAmount.toLocaleString(void 0, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          );
                      }
                    }
                  })(c, r, e);
                  break;
                case "fixed_amount":
                  !(function (e, t, r) {
                    var c = e / 100;
                    "ILS" === Shopify.currency.active
                      ? (t.querySelector(".price").innerHTML = ""
                          .concat(
                            c.toLocaleString(void 0, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          )
                          .concat(window.currencies[Shopify.currency.active]))
                      : (t.querySelector(".price").innerHTML = ""
                          .concat(window.currencies[Shopify.currency.active])
                          .concat(
                            c.toLocaleString(void 0, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          ));
                  })(c, r);
                  break;
                case "price":
                  !(function (e, t) {
                    "ILS" === Shopify.currency.active
                      ? (e.querySelector(".price").innerHTML = ""
                          .concat(
                            t.toLocaleString(void 0, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          )
                          .concat(window.currencies[Shopify.currency.active]))
                      : (e.querySelector(".price").innerHTML = ""
                          .concat(window.currencies[Shopify.currency.active])
                          .concat(
                            t.toLocaleString(void 0, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          ));
                  })(r, e);
              }
            })(
              e.price_adjustments[0].value,
              e.price_adjustments[0].value_type
            ));
        }));
  }
  function c(r) {
    var c = document.querySelector(r);
    fetch(window.location)
      .then(function (e) {
        return e.text();
      })
      .then(function (i) {
        var n = document.createElement("div");
        n.innerHTML = i;
        var a = n.querySelector(r);
        a &&
          ((c.innerHTML = ""),
          c.insertAdjacentHTML("afterbegin", a.innerHTML),
          e(t, !0)),
          (function (e) {
            var t = e.querySelector(".js-cart-counter"),
              r = document.querySelector(".js-cart-counter");
            t &&
              ((r.innerHTML = ""),
              r.insertAdjacentHTML("afterbegin", t.innerHTML));
          })(n),
          document
            .querySelector(".js-cart-drawer")
            .classList.remove("loader-active");
      });
  }
  document.addEventListener("DOMContentLoaded", function () {
    !(function () {
      var e = document.querySelector(".js-subscription-select"),
        c = document.querySelectorAll(".js-subscription-radio"),
        i = document.querySelectorAll(".b-buy-box .js-add-to-cart"),
        // n = document.querySelectorAll(".js-variant-select"),
        a = document.querySelector(".c-quantity-pdp"),
        o = document.querySelector(".js-subscriptions");
      e &&
        e.addEventListener("change", function (e) {
          o.checked || (o.checked = !0), r(e, !0), (o.value = e.target.value);
        });
      c &&
        c.forEach(function (e) {
          e.addEventListener("click", function (e) {
            if (!e.target.classList.contains("js-subscriptions") && !e.target.classList.contains("js-membership-purchase")) {
              // var t = document.querySelector(".b-buy-box__product-pricing");
              setTimeout(() => {
                
                var submoneyText = document.querySelector('.b-buy-box__plans input.js-one-time-purchase:checked ~ .one_time_price .priceblock .money');
                if (submoneyText) {
                  var submoneyValue = submoneyText.textContent.trim();
                  console.log(submoneyValue);
                  var span_money = document.querySelector('.b-buy-box__product-pricing span.price');
                  if (span_money) {
                    span_money.textContent = submoneyValue;
                    console.log('Text content updated successfully aa');
                    document.querySelector(".b-buy-box__buy-actions .js-add-to-cart").setAttribute("data-selling-plan", "");
                  }
                  var disc_com_price = document.querySelector('.b-buy-box__product-pricing .price-compare');
                  if (disc_com_price) {
                    var disc_main_price = parseFloat(submoneyValue.replace('$', '').split('.')[0]);
                    var disc_com_price_class = parseFloat(disc_com_price.textContent.replace('$', '').split('.')[0]);
                    console.log(disc_com_price_class, disc_main_price)
                    var disc_sub_amount_subscription_final_amount = disc_com_price_class - disc_main_price;
                    var disc_subscription_price = document.querySelector('.discount-span-block.savings');
                    console.log(disc_sub_amount_subscription_final_amount, disc_subscription_price)
                    disc_subscription_price.textContent = 'Save $' + disc_sub_amount_subscription_final_amount+'.00';
                    document.querySelector(".variant-button.active .savings .money").textContent = "$" + disc_sub_amount_subscription_final_amount + ".00";
                  }
                }
              }, 150);
              var discountAmount = window.product_compare_price - window.product_price;
              if (Shopify.currency.active === "ILS") {
                t.querySelector(".price").innerHTML = ""
                  .concat(
                    (window.product_price / 100).toLocaleString(void 0, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  )
                  .concat(window.currencies[Shopify.currency.active]);
                if (discountAmount > 0) {
                  t.querySelector(".savings span.money").innerHTML = ""
                    .concat(
                      (discountAmount / 100).toLocaleString(void 0, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    )
                    .concat(window.currencies[Shopify.currency.active]);
                }
              } else {
                t.querySelector(".price").innerHTML = ""
                  .concat(window.currencies[Shopify.currency.active])
                  .concat(
                    (window.product_price / 100).toLocaleString(void 0, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  );
                if (discountAmount > 0) {
                  t.querySelector(".savings span.money").innerHTML = ""
                    .concat(window.currencies[Shopify.currency.active])
                    .concat(
                      (discountAmount / 100).toLocaleString(void 0, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    );
                }
              }
            }
            r(e, !0);
          });
        });
      var subscription_opt = document.querySelector(
        ".js-subscription-select.subscribe-select"
      );
      if (subscription_opt) {
        subscription_opt.addEventListener("change", function (e) {
          var subscribeText = document.querySelector(
            ".b-buy-box__plans input.js-subscriptions:checked ~ .one_time_price .subscription-only-price #discounted-price.money"
          );
          // console.log(subscribeText)
          if (subscribeText) {
            setTimeout(() => {
              console.log(subscribeText.textContent.trim());
              var subscriptions_span_money = document.querySelector(
                ".b-buy-box__product-pricing span.price"
              );
              if (subscriptions_span_money) {
                subscriptions_span_money.textContent =
                  subscribeText.textContent.trim();
                console.log("Text content updated successfully");
                console.log("aa1");

               /* Variant Wise Price Update */  
               /*// Get the discounted price
              var element = document.querySelector('#discounted-price');
              var text = element ? element.textContent : null;  // Check if the element exists
              console.log('Discounted Price:', text);
              
              // Get the original price
              var priceElement = document.querySelector(".subcrp-disc-amt .price .money_text .money");
              var price = priceElement ? priceElement.textContent : null;  // Check if the element exists
              console.log('Original Price:', price);
              
              // Convert the text values to numbers (remove any non-numeric characters if needed)
              var priceNum = price ? parseFloat(price.replace(/[^0-9.-]+/g, "")) : 0;
              var textNum = text ? parseFloat(text.replace(/[^0-9.-]+/g, "")) : 0;
              
              // Perform the subtraction
              var result = priceNum - textNum;
              console.log('Price after discount (raw):', result);
              
              // Format the result to two decimal places with a dollar sign
              var formattedResult = result.toFixed(2);  // This rounds the result to two decimal places
              var formattedPrice = "$" + formattedResult;
              
              console.log('Formatted Price after discount:', formattedPrice);

               var discountElement = document.querySelector(".b-buy-box__product-pricing .discount-span-block");
                if (discountElement) {
                    discountElement.textContent = "Save " + formattedPrice;  // Set the text to "Save" + formattedPrice
                }*/

                /*var comparePriceElement = document.querySelector(".b-buy-box__product-pricing .price-compare");
                if (comparePriceElement) {
                    comparePriceElement.textContent = price;
                }*/


                
                var disc_com_price = document.querySelector(
                  ".b-buy-box__product-pricing .price-compare"
                );
                if (disc_com_price) {
                  var disc_main_price = parseFloat(
                    subscriptions_span_money.replace("$", "").split(".")[0]
                  );
                  var disc_com_price_class = parseFloat(
                    disc_com_price.textContent.replace("$", "").split(".")[0]
                  );
                  console.log(disc_com_price_class, disc_main_price);
                  var disc_sub_amount_subscription_final_amount =
                    disc_com_price_class - disc_main_price;
                  var disc_subscription_price = document.querySelector(
                    ".discount-span-block.savings"
                  );
                  console.log("disc_sub_amount_subscription_final_amount" + 111);
                  console.log(
                    disc_sub_amount_subscription_final_amount,
                    disc_subscription_price
                  );
                  disc_subscription_price.textContent =
                    "Save $" +
                    disc_sub_amount_subscription_final_amount +
                    ".00";
                  if (
                    document.querySelector(
                      ".variant-button.active .savings .money"
                    )
                  ) {
                    document.querySelector(
                      ".variant-button.active .savings .money"
                    ).textContent =
                      "$" + disc_sub_amount_subscription_final_amount + ".00";
                  }
                }
              }
            }, 100);
          }
        });
      }

      const subscriptions_button = document.querySelector(".js-subscriptions");
      if (subscriptions_button) {
        subscriptions_button.addEventListener("click", function (e) {
          // console.log("Subscription clicked");
          var subscribeText = document.querySelector('.b-buy-box__plans input.js-subscriptions:checked ~ .one_time_price .subscription-only-price #discounted-price.money');
          // console.log(subscribeText)
          if (subscribeText) {
            setTimeout(() => {
              // console.log(subscribeText.textContent.trim());
              var subscriptions_span_money = document.querySelector('.b-buy-box__product-pricing span.price');
              if (subscriptions_span_money) {
                subscriptions_span_money.textContent = subscribeText.textContent.trim();
                console.log('Text content updated successfully');
                var disc_com_price = document.querySelector('.b-buy-box__product-pricing .price-compare');
                if (disc_com_price) {
                  console.log(subscribeText, 'subscriptions_span_money')
                  var disc_main_price = parseFloat(subscribeText.textContent.replace('$', '').split('.')[0]);
                  var disc_com_price_class = parseFloat(disc_com_price.textContent.replace('$', '').split('.')[0]);
                  console.log(disc_com_price_class, disc_main_price)
                  var disc_sub_amount_subscription_final_amount = disc_com_price_class - disc_main_price;
                  var disc_subscription_price = document.querySelector('.discount-span-block.savings');
                  console.log(disc_sub_amount_subscription_final_amount, disc_subscription_price)
                  disc_subscription_price.textContent = 'Save $' + disc_sub_amount_subscription_final_amount+'.00';
                  document.querySelector(".variant-button.active .savings .money").textContent = "$" + disc_sub_amount_subscription_final_amount + ".00";
                }
              }
            }, 100);
          }
        });
      }

      const member_subscriptions_button = document.querySelector(".js-membership-purchase");
      if (member_subscriptions_button) {
        member_subscriptions_button.addEventListener("click", function (e) {
          var member_text = document.querySelector('#membership-selling-plan input.js-membership-purchase:checked ~ .one_time_price .members-only-price .money');
          if (member_text) {
            setTimeout(() => {
              console.log(member_text.textContent.trim());
              var member_subscriptions_span_money = document.querySelector('.b-buy-box__product-pricing span.price');
              if (member_subscriptions_span_money) {
                member_subscriptions_span_money.textContent = member_text.textContent.trim();
                console.log('member_text Text content updated successfully');
                
                var disc_com_price = document.querySelector('.b-buy-box__product-pricing .price-compare');
                if (disc_com_price) {
                  var disc_main_price = parseFloat(member_text.textContent.replace('$', '').split('.')[0]);
                  var disc_com_price_class = parseFloat(disc_com_price.textContent.replace('$', '').split('.')[0]);
                  console.log(disc_com_price_class, disc_main_price)
                  var disc_sub_amount_subscription_final_amount = disc_com_price_class - disc_main_price;
                  var disc_subscription_price = document.querySelector('.discount-span-block.savings');
                  console.log(disc_sub_amount_subscription_final_amount, disc_subscription_price)
                  disc_subscription_price.textContent = 'Save $' + disc_sub_amount_subscription_final_amount+'.00';
                  document.querySelector(".variant-button.active .savings .money").textContent = "$" + disc_sub_amount_subscription_final_amount + ".00";
                }
                
              }
            }, 100);
          }
        });
      }

      if (a) {
        var u = a.querySelector(".c-quantity__amount"),
          s = a.querySelector(".c-quantity-pdp-increase"),
          d = a.querySelector(".c-quantity-pdp-decrease"),
          l = parseInt(u.textContent.trim());
        i.length && (i[0].dataset.quantity = l),
          s.addEventListener("click", function () {
            l++,
              (u.textContent = l),
              (i[0].dataset.quantity = l),
              d.removeAttribute("disabled");
          }),
          d.addEventListener("click", function () {
            l > 1 && (l--, (u.textContent = l), (i[0].dataset.quantity = l)),
              1 === l && d.setAttribute("disabled", "disabled");
          });
      }
      i &&
        i.forEach(function (e) {
          e.addEventListener("click", function (e) {
            try {
              var r = {
                id: e.target.dataset.id,
                quantity: e.target.dataset.quantity,
                selling_plan: e.target.dataset.sellingPlan,
              };
              document
                .querySelector(".js-cart-drawer")
                .classList.add("loader-active"),
                t(r);
            } catch (e) {
              throw e;
            }
          });
        });

      /*var subscription_change_option = document.querySelector(
        ".js-subscription-select"
      );
      subscription_change_option.addEventListener("change", function (sub_opt) {
        var subscription_only_price = document.querySelector(
          ".subscription-only-price .line-through .money .money"
        );
        var subscription_save_percentage = document.querySelector(
          ".subscription-plan .sellingcontent .subscription-percent"
        );

        if (subscription_save_percentage) {
          // Get the subscription percentage and clean it up by removing '% OFF'
          var subscription_percentage = subscription_save_percentage.textContent
            .replace("% OFF", "")
            .trim();
          // Convert the price to a numeric value by removing the dollar sign and parsing it as a float
          var subscription_numericPrice = parseFloat(
            subscription_only_price.textContent.replace("$", "").trim()
          );
          // Calculate the discount amount
          var subscription_sub_amount_subscription =
            (subscription_numericPrice * parseFloat(subscription_percentage)) /
            100;
          // Calculate the final amount after discount
          var subscription_sub_amount_subscription_final_amount =
            subscription_numericPrice - subscription_sub_amount_subscription;
          // Get the element to update with the discounted price
          var subscription_discounted_price =
            document.querySelector("#discounted-price");
          if (subscription_discounted_price) {
            // Update the discounted price, formatted as a dollar amount
            subscription_discounted_price.textContent =
              "$" +
              subscription_sub_amount_subscription_final_amount.toFixed(2);
          }
        }
      });*/

      var subscription_change_option = document.querySelector(".js-subscription-select");
      if(subscription_change_option) {
        subscription_change_option.addEventListener("change", function (sub_opt) {
          var subscription_only_price = document.querySelector('.subscription-only-price .line-through .money .money');
          var subscription_save_percentage = document.querySelector('.subscription-plan .sellingcontent .subscription-percent');
          
          if (subscription_save_percentage) {
            // Get the subscription percentage and clean it up by removing '% OFF'
            var subscription_percentage = subscription_save_percentage.textContent.replace('% OFF', '').trim();
            // Convert the price to a numeric value by removing the dollar sign and parsing it as a float
            var subscription_numericPrice = parseFloat(subscription_only_price.textContent.replace('$', '').trim());
            // Calculate the discount amount
            var subscription_sub_amount_subscription = subscription_numericPrice * parseFloat(subscription_percentage) / 100;
            // Calculate the final amount after discount
            var subscription_sub_amount_subscription_final_amount = subscription_numericPrice - subscription_sub_amount_subscription;
            // Get the element to update with the discounted price
            var subscription_discounted_price = document.querySelector('#discounted-price');
            if (subscription_discounted_price) {
              // Update the discounted price, formatted as a dollar amount
              subscription_discounted_price.textContent = '$' + subscription_sub_amount_subscription_final_amount.toFixed(2);
            }
          }
        });
      }

      var variant_select = document.querySelectorAll(".js-variant-select");
      variant_select.forEach(function (selected_variant) {
        selected_variant.addEventListener("click", function (event) {

          /* soldout disable class add */
          var addToCartButton = document.querySelector('.btn--add-to-cart.js-add-to-cart');
          if (selected_variant.classList.contains('out-of-stock')) {
            if (addToCartButton) {
              addToCartButton.setAttribute('disabled', 'true');
            }
          } else {
            if (addToCartButton) {
              addToCartButton.removeAttribute('disabled');
            }
          }
          
          document.querySelector(".js-add-to-cart").dataset.id = selected_variant.dataset.id;
          setTimeout(() => {
              var moneyTextElement = document.querySelector('.js-variant-select.active .form__price__block .money');
              var targetMoneyElement = document.querySelector('.b-buy-box__product-pricing .price .money');
              if (moneyTextElement && targetMoneyElement) {
                var moneyText = moneyTextElement.textContent;
                targetMoneyElement.textContent = moneyText;
              }
              console.log(targetMoneyElement, 'targetMoneyElement')
              // compare price variant
              var comparemoneyTextElement = document.querySelector('.js-variant-select.active .form__compareprice__block .money');
              console.log(comparemoneyTextElement, 'comparemoneyTextElement')
              if (comparemoneyTextElement) {
                var comparemoneyText = comparemoneyTextElement.textContent;
                var compare_price = document.querySelector('.b-buy-box__product-pricing .price-compare');
                console.log(compare_price, 'compare_price')
                if (compare_price) {
                  compare_price.textContent = comparemoneyText;
                  var comparemoney_amt = comparemoneyText;
                  var money_amt = moneyText;
                  var comparemoneyValue = parseFloat(comparemoney_amt.replace('$', '').replace(',', ''));
                  if (money_amt) {
                    var moneyValue = parseFloat(money_amt.replace('$', '').replace(',', ''));
                    var save_amt = "Save $" + (comparemoneyValue - moneyValue).toFixed(2);
                    
                    // Log the values and savings
                    document.querySelector('.discount-span-block').classList.add('savings');
                    document.querySelector('.discount-span-block').textContent = save_amt;
                  }
                }
              } else {
                var comparemoneyText = '';
                var compare_price = document.querySelector('.b-buy-box__product-pricing .price-compare');
                if (compare_price) {
                  compare_price.textContent = comparemoneyText;
                  document.querySelector('.discount-span-block').classList.remove('savings');
                  document.querySelector('.discount-span-block').textContent = '';
                }
              }
              
              var variantText = document.querySelector('.js-variant-select.active .form__label__value').textContent;
              document.querySelector('.b-buy-box__variants-wrapper h4 span').textContent = variantText;
              var submoneyText = document.querySelector('.b-buy-box__plans input.js-subscription-radio:checked + #discounted-price .money');
              if (submoneyText) {
                var submoneyValue = submoneyText.textContent;
                console.log(submoneyValue)
                document.querySelector('.b-buy-box__product-pricing .price .money').textContent = submoneyValue;
              }
              
              if (moneyTextElement) {
                var moneyText = moneyTextElement.textContent;
                var sub_one_time = document.querySelector('.one_time_price .priceblock .money');
                var subscription_only_price = document.querySelector('.subscription-only-price .line-through .money .money');
                var save_percentage = document.querySelector('.subscription-plan .sellingcontent .subscription-percent');
                // console.log(save_percentage.textContent, 'save_percentage')
                if (sub_one_time) {
                  sub_one_time.textContent = moneyText;
                }
                if (subscription_only_price) {
                  subscription_only_price.textContent = moneyText;
                }
                
                // subscription month
                if (save_percentage) {
                  var percentage = save_percentage.textContent.replace('% OFF', '');
                  var numericPrice = parseFloat(subscription_only_price.textContent.replace('$', '').split('.')[0]);
                  var sub_amount_subscription = numericPrice * percentage / 100;
                  var sub_amount_subscription_final_amount = numericPrice - sub_amount_subscription;
                  var discounted_price = document.querySelector('#discounted-price');
                  if (discounted_price) {
                    discounted_price.textContent = '$' + sub_amount_subscription_final_amount+'.00';
                  }
                }
                
                // Membership
                var member_save_percentage = document.querySelector('#membership-selling-plan .save_percentage');
                var member_subscription_only_price = document.querySelector('#membership-selling-plan .line-through .money');
                if (member_subscription_only_price) {
                  member_subscription_only_price.textContent = moneyText;
                }
                if (member_save_percentage) {
                  var member_percentage = member_save_percentage.textContent.replace('% OFF', '');
                  var member_numericPrice = parseFloat(member_subscription_only_price.textContent.replace('$', '').split('.')[0]);
                  var member_sub_amount_subscription = member_numericPrice * member_percentage / 100;
                  var member_sub_amount_subscription_final_amount = member_numericPrice - member_sub_amount_subscription;
                  var member_subscription_price = document.querySelector('#membership-selling-plan .members-only-price .money');
                  member_subscription_price.textContent = '$' + member_sub_amount_subscription_final_amount+'.00';
                }
              }
              
              // Order Once
              var submoneyText = document.querySelector('.b-buy-box__plans input.js-one-time-purchase:checked ~ .one_time_price .priceblock .money');
              if (submoneyText) {
                var submoneyValue = submoneyText.textContent.trim();
                // console.log(submoneyValue);
                var span_money = document.querySelector('.b-buy-box__product-pricing span.price');
                if (span_money) {
                  span_money.textContent = submoneyValue;
                  console.log('Text content updated successfully');
                }
              }
              // BecomeMemberText
              var BecomeMemberText = document.querySelector('.b-buy-box__plans input.js-membership-purchase:checked ~ .one_time_price .members-only-price .money');
              if (BecomeMemberText) {
                var BecomeMemberTextValue = BecomeMemberText.textContent.trim();
                var member_span_money = document.querySelector('.b-buy-box__product-pricing span.price');
                if (member_span_money) {
                  member_span_money.textContent = BecomeMemberTextValue;
                  console.log('Text content updated successfully');
                }
                var disc_com_price = document.querySelector('.b-buy-box__product-pricing .price-compare');
                if (disc_com_price) {
                  var disc_main_price = parseFloat(BecomeMemberTextValue.replace('$', '').split('.')[0]);
                  var disc_com_price_class = parseFloat(disc_com_price.textContent.replace('$', '').split('.')[0]);
                  console.log(disc_com_price_class, disc_main_price)
                  var disc_sub_amount_subscription_final_amount = disc_com_price_class - disc_main_price;
                  var disc_subscription_price = document.querySelector('.discount-span-block.savings');
                  console.log(disc_sub_amount_subscription_final_amount, disc_subscription_price)
                  if (disc_subscription_price) {
                    disc_subscription_price.textContent = 'Save $' + disc_sub_amount_subscription_final_amount+'.00';
                  }
                  const element = document.querySelector(".variant-button.active .savings .money");
                  if (element) {
                    element.textContent = "$" + disc_sub_amount_subscription_final_amount + ".00";
                  }
                }
              }
              // Subscribe & Save
              var subscribeText = document.querySelector('.b-buy-box__plans input.js-subscriptions:checked ~ .one_time_price .subscription-only-price #discounted-price.money');
              // console.log(subscribeText)
              if (subscribeText) {
                setTimeout(() => {
                  // console.log(subscribeText.textContent.trim());
                  var subscriptions_span_money = document.querySelector('.b-buy-box__product-pricing span.price');
                  if (subscriptions_span_money) {
                    subscriptions_span_money.textContent = subscribeText.textContent.trim();
                    console.log('Text content updated successfully');
                    var disc_com_price = document.querySelector('.b-buy-box__product-pricing .price-compare');
                    if (disc_com_price) {
                      console.log(subscribeText, 'subscriptions_span_money')
                      var disc_main_price = parseFloat(subscribeText.textContent.replace('$', '').split('.')[0]);
                      var disc_com_price_class = parseFloat(disc_com_price.textContent.replace('$', '').split('.')[0]);
                      console.log(disc_com_price_class, disc_main_price)
                      var disc_sub_amount_subscription_final_amount = disc_com_price_class - disc_main_price;
                      var disc_subscription_price = document.querySelector('.discount-span-block.savings');
                      console.log(disc_sub_amount_subscription_final_amount, disc_subscription_price)
                      disc_subscription_price.textContent = 'Save $' + disc_sub_amount_subscription_final_amount+'.00';
                      document.querySelector(".variant-button.active .savings .money").textContent = "$" + disc_sub_amount_subscription_final_amount + ".00";
                    }
                  }
                }, 100);
              }
              const element = document.querySelector(".js-subscription-select.subscribe-select");
              if (element) {
                element.addEventListener("change", function (e) {
                  var subscribeText = document.querySelector('.b-buy-box__plans input.js-subscriptions:checked ~ .one_time_price .subscription-only-price #discounted-price.money');
                  var member_text = document.querySelector('#membership-selling-plan input.js-membership-purchase:checked ~ .one_time_price .members-only-price .money');
                  // console.log(subscribeText)
                  if (subscribeText) {
                    setTimeout(() => {
                      console.log(subscribeText.textContent.trim());
                      var subscriptions_span_money = document.querySelector('.b-buy-box__product-pricing span.price');
                      if (subscriptions_span_money) {
                        subscriptions_span_money.textContent = subscribeText.textContent.trim();
                        console.log('Text content updated successfully');
                      }
                      var disc_com_price = document.querySelector('.b-buy-box__product-pricing .price-compare');
                      if (disc_com_price) {
                        var disc_main_price = parseFloat(subscribeText.textContent.replace('$', '').split('.')[0]);
                        var disc_com_price_class = parseFloat(disc_com_price.textContent.replace('$', '').split('.')[0]);
                        console.log(disc_com_price_class, disc_main_price)
                        var disc_sub_amount_subscription_final_amount = disc_com_price_class - disc_main_price;
                        var disc_subscription_price = document.querySelector('.discount-span-block.savings');
                        console.log(disc_sub_amount_subscription_final_amount, disc_subscription_price)
                        disc_subscription_price.textContent = 'Save $' + disc_sub_amount_subscription_final_amount+'.00';
                        document.querySelector(".variant-button.active .savings .money").textContent = "$" + disc_sub_amount_subscription_final_amount + ".00";
                      }
                    }, 100);
                  }
                  if (member_text) {
                    setTimeout(() => {
                      console.log(subscribeText.textContent.trim());
                      var subscriptions_span_money = document.querySelector('.b-buy-box__product-pricing span.price');
                      if (subscriptions_span_money) {
                        subscriptions_span_money.textContent = subscribeText.textContent.trim();
                        console.log('Text content updated successfully');
                      }
                      
                    }, 100);
                  }
                });
              }
          }, 200);
          /*(window.product_price = t.price),
            document
              .querySelectorAll(".b-buy-box__product-pricing")
              .forEach(function (e) {
                var r,
                  c = e.querySelector(".price"),
                  i = e.querySelector(".price-compare"),
                  n = e.querySelector(".savings"),
                  a = window.currencies[Shopify.currency.active];
                var oneTimePurchase = document.querySelector(
                  ".js-one-time-purchase"
                );
                if (oneTimePurchase) {
                  document.querySelector(".js-one-time-purchase").checked
                    ? (r = t.price)
                    : "percentage" === window.discount.type
                    ? (r = t.price - (t.price * window.discount.value) / 100)
                    : "fixed_amount" === window.discount.type
                    ? (r = t.price - window.discount.value)
                    : "price" === window.discount.type &&
                      (r = window.discount.value),
                    "ILS" === Shopify.currency.active
                      ? ((c.innerHTML =
                          (r / 100).toLocaleString(void 0, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }) + a),
                        t.compare_at_price &&
                          ((i.innerHTML =
                            (t.compare_at_price / 100).toLocaleString(void 0, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) + a),
                          n &&
                            (n.innerHTML =
                              "Save " +
                              (
                                (t.compare_at_price - t.price) /
                                100
                              ).toLocaleString(void 0, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }) +
                              a)))
                      : ((c.innerHTML =
                          a +
                          (r / 100).toLocaleString(void 0, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })),
                        t.compare_at_price &&
                          ((i.innerHTML =
                            a +
                            (t.compare_at_price / 100).toLocaleString(void 0, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })),
                          n &&
                            (n.innerHTML =
                              "Save " +
                              a +
                              (
                                (t.compare_at_price - t.price) /
                                100
                              ).toLocaleString(void 0, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }))));
                } 
              });*/
        });
      });
    })(),
      (function () {
        var e = document.querySelector(".js-variant-select.active");
        if (e) {
          var t = new URL(window.location.href),
            r = t.searchParams;
          r.set("variant", e.dataset.id),
            (t.search = r.toString()),
            window.history.pushState({}, "", t);
        }
      })();
  });
})();
